<template>
  <div class="section-parameter">
    <div class="col-left">
      <h2>Events</h2>
    </div>
    <div class="col-right" v-if="events.length > 0">
      <div v-for="event in events" :key="event.id">
        <event :id="event.id"></event>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'
import event from '@/components/settings/translations/translations_event'

export default {
  components: { event },
  watch: {
    site: function (site) {
      this.init()
    }
  },
  computed: {
    ...mapGetters('account', {
      site: 'currentSite'
    }),
    ...mapGetters('events', {
      'events': 'events'
    })
  },
  methods: {
    ...mapActions('events', ['loadEvents']),

    init () {
      if (this.site) {
        this.loadEvents()
      }
    }
  },

  mounted () {
    this.init()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/settings/translations/translations_events.vue